import { Layout } from "ui-components/Layout";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { formRender, initialValues, countryValidations } from "./country-schema";
import CountryInfo from "./components/CountryInfo";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getCountryByCode, editCountry } from "services/data.internal.service";
import { useState } from "react";
import { Success, Error_ } from "ui-components/Alert";
import { useLocation } from "react-router-dom";
import { SaveButton } from "ui-components/Form";

function EditCountry() {
  const location = useLocation();
  const { countryCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const onSuccess = (data) => setAlert(<Success data={data} onChange={setAlert} />);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const queryClient = useQueryClient();
  useQuery({
    queryKey: ["country", { countryCode }],
    queryFn: () => getCountryByCode(countryCode),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });
  const editCountryMutation = useMutation(editCountry, {
    onSuccess,
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(countryValidations),
  });
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = form;
  const infoProps = {
    formRender,
    mode: "EDIT",
    control,
    errors,
  };
  const onSubmit = (data) => {
    editCountryMutation.mutate(data, {
      onSuccess: () => queryClient.invalidateQueries(["country"]),
    });
  };
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <CountryInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty} url="/setup/country" />
      </form>
    </Layout>
  );
}

export default EditCountry;
